enum MediaType {
  Asset = 'Asset',
  Shared = 'Shared',
  TullyBeat = 'TullyBeat',
  ImportedBeat = 'ImportedBeat',
}

export default MediaType;
